import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { LoadErrorBox } from "../../components/common/LoadErrorBox";
import { Loader2, Coins } from "lucide-react";

const fmtDT = (s) => (s ? new Date(s).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "—");

export default function SuperAdminAiCosts() {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  const load = () => {
    setFailed(false);
    api.get("/superadmin/ai-usage")
      .then(({ data: d }) => setData(d))
      .catch(() => setFailed(true));
  };
  useEffect(load, []);

  if (failed) return <LoadErrorBox what="i costi AI" onRetry={load} testId="ai-costs-error" />;
  if (!data) return <div className="py-16 text-center text-text-muted"><Loader2 className="animate-spin mx-auto" size={20} /></div>;

  return (
    <div className="space-y-6" data-testid="ai-costs-page">
      <div>
        <h1 className="text-2xl font-semibold text-text-primary flex items-center gap-2.5">
          <Coins size={22} className="text-accent-strong" /> Costi AI
        </h1>
        <p className="text-sm text-text-secondary mt-1">
          Consumi LLM per tenant (Assistente AI — Strumenti). {data.note}
        </p>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[
          ["Chiamate", data.totals.calls.toLocaleString("it-IT")],
          ["Token input", data.totals.tokens_in.toLocaleString("it-IT")],
          ["Token output", data.totals.tokens_out.toLocaleString("it-IT")],
          ["Costo stimato", `$ ${data.totals.cost_usd.toFixed(4)}`],
        ].map(([label, value]) => (
          <div key={label} className="bg-surface border border-border rounded-xl p-5" data-testid={`ai-costs-kpi-${label.toLowerCase().replace(/\s/g, "-")}`}>
            <div className="text-xs text-text-muted uppercase tracking-wider mb-1.5">{label}</div>
            <div className="text-2xl font-semibold text-text-primary">{value}</div>
          </div>
        ))}
      </div>

      {data.tenants.length === 0 ? (
        <div className="bg-surface border border-border rounded-xl p-10 text-center text-sm text-text-muted" data-testid="ai-costs-empty">
          Nessun consumo AI registrato ancora.
        </div>
      ) : (
        <div className="bg-surface border border-border rounded-xl overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]" data-testid="ai-costs-table">
            <thead className="bg-subtle text-xs uppercase tracking-wider text-text-secondary">
              <tr>
                <th className="text-left px-5 py-3 font-medium">Tenant</th>
                <th className="text-right px-3 py-3 font-medium">Chiamate</th>
                <th className="text-right px-3 py-3 font-medium">Token in</th>
                <th className="text-right px-3 py-3 font-medium">Token out</th>
                <th className="text-right px-3 py-3 font-medium">Costo stimato</th>
                <th className="text-left px-5 py-3 font-medium">Ultima chiamata</th>
              </tr>
            </thead>
            <tbody>
              {data.tenants.map((t) => (
                <tr key={t.org_id} className="border-t border-border" data-testid={`ai-costs-row-${t.org_id}`}>
                  <td className="px-5 py-3 text-text-primary font-medium">{t.org_name}</td>
                  <td className="px-3 py-3 text-right">{t.calls.toLocaleString("it-IT")}</td>
                  <td className="px-3 py-3 text-right text-text-secondary">{t.tokens_in.toLocaleString("it-IT")}</td>
                  <td className="px-3 py-3 text-right text-text-secondary">{t.tokens_out.toLocaleString("it-IT")}</td>
                  <td className="px-3 py-3 text-right font-medium">$ {t.cost_usd.toFixed(4)}</td>
                  <td className="px-5 py-3 text-xs text-text-secondary">{fmtDT(t.last_call)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
